export default
{
    PageType:
    {
        ProjectList: "list",
        Project: "work",
        Misc: "art"
    },

    ProjectCategory:
    {
        LongTerm: "long-term",
        Experimental: "experimental",
        Art: "art"
    }
}